import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios' // remove comment if yu needed
import Crud from '../crud'
import app from '../../main' // import the instance
import checkResponse from '@/utils/checkResponse'
const model = (payload) => ({
  // columns
  id: payload.id,
  name: payload.name,
  location: payload.location
})
var crud = new Crud('Suppliers', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  suppliers: [],
  supplier: {}
}

const mutations = {
  ...crud.mutations
}
const actions = {
  ...crud.actions,
  async assignDeposit ({ commit }, payload) {
    app.$Progress.start()

    try {
      const response = await axios.post(`suppliers/${payload.id}/pay`, payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.suppliers', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
        commit('ConceptableConcepts/ADD_RECORD', response.data.concepts[0], { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  }

}

const getters = {
  ...crud.getters,
  suppliers: state => state.suppliers,
  supplier: state => state.supplier,
  catalog: state => state.catalog
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
